// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as NdaScannerRouteImport } from './routes/nda-scanner'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as DocumentTypesRouteImport } from './routes/document-types'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as ClauseHistoryRouteImport } from './routes/clause-history'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AffiliatesRouteImport } from './routes/affiliates'
import { Route as AdsenseTestRouteImport } from './routes/adsense-test'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as QuestionsIndexRouteImport } from './routes/questions.index'
import { Route as ClausesIndexRouteImport } from './routes/clauses.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as ToolsSlugRouteImport } from './routes/tools.$slug'
import { Route as SharedTokenRouteImport } from './routes/shared.$token'
import { Route as ScenariosFirstApartmentLeaseRouteImport } from './routes/scenarios.first-apartment-lease'
import { Route as ScenariosSlugRouteImport } from './routes/scenarios.$slug'
import { Route as QuestionsSlugRouteImport } from './routes/questions.$slug'
import { Route as LeaseRedFlagsStateRouteImport } from './routes/lease-red-flags.$state'
import { Route as ClausesSlugRouteImport } from './routes/clauses.$slug'
import { Route as DocumentTypesSlugRouteImport } from './routes/document-types.$slug'
import { Route as ClauseHistoryContractIdRouteImport } from './routes/clause-history.$contractId'
import { Route as BlogCategoryIndexRouteImport } from './routes/blog.$category.index'
import { Route as BlogCategorySlugRouteImport } from './routes/blog.$category.$slug'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const NdaScannerRoute = NdaScannerRouteImport.update({
            id: '/nda-scanner',path: '/nda-scanner',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const DocumentTypesRoute = DocumentTypesRouteImport.update({
            id: '/document-types',path: '/document-types',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CompareRoute = CompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => rootRouteImport
          })
const ClauseHistoryRoute = ClauseHistoryRouteImport.update({
            id: '/clause-history',path: '/clause-history',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AffiliatesRoute = AffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => rootRouteImport
          })
const AdsenseTestRoute = AdsenseTestRouteImport.update({
            id: '/adsense-test',path: '/adsense-test',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const QuestionsIndexRoute = QuestionsIndexRouteImport.update({
            id: '/questions/',path: '/questions/',getParentRoute: () => rootRouteImport
          })
const ClausesIndexRoute = ClausesIndexRouteImport.update({
            id: '/clauses/',path: '/clauses/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const ToolsSlugRoute = ToolsSlugRouteImport.update({
            id: '/tools/$slug',path: '/tools/$slug',getParentRoute: () => rootRouteImport
          })
const SharedTokenRoute = SharedTokenRouteImport.update({
            id: '/shared/$token',path: '/shared/$token',getParentRoute: () => rootRouteImport
          })
const ScenariosFirstApartmentLeaseRoute = ScenariosFirstApartmentLeaseRouteImport.update({
            id: '/scenarios/first-apartment-lease',path: '/scenarios/first-apartment-lease',getParentRoute: () => rootRouteImport
          })
const ScenariosSlugRoute = ScenariosSlugRouteImport.update({
            id: '/scenarios/$slug',path: '/scenarios/$slug',getParentRoute: () => rootRouteImport
          })
const QuestionsSlugRoute = QuestionsSlugRouteImport.update({
            id: '/questions/$slug',path: '/questions/$slug',getParentRoute: () => rootRouteImport
          })
const LeaseRedFlagsStateRoute = LeaseRedFlagsStateRouteImport.update({
            id: '/lease-red-flags/$state',path: '/lease-red-flags/$state',getParentRoute: () => rootRouteImport
          })
const ClausesSlugRoute = ClausesSlugRouteImport.update({
            id: '/clauses/$slug',path: '/clauses/$slug',getParentRoute: () => rootRouteImport
          })
const DocumentTypesSlugRoute = DocumentTypesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => DocumentTypesRoute
          })
const ClauseHistoryContractIdRoute = ClauseHistoryContractIdRouteImport.update({
            id: '/$contractId',path: '/$contractId',getParentRoute: () => ClauseHistoryRoute
          })
const BlogCategoryIndexRoute = BlogCategoryIndexRouteImport.update({
            id: '/blog/$category/',path: '/blog/$category/',getParentRoute: () => rootRouteImport
          })
const BlogCategorySlugRoute = BlogCategorySlugRouteImport.update({
            id: '/blog/$category/$slug',path: '/blog/$category/$slug',getParentRoute: () => rootRouteImport
          })





const ClauseHistoryRouteChildren = {
  ClauseHistoryContractIdRoute: ClauseHistoryContractIdRoute
}

const ClauseHistoryRouteWithChildren = ClauseHistoryRoute._addFileChildren(ClauseHistoryRouteChildren)




const DocumentTypesRouteChildren = {
  DocumentTypesSlugRoute: DocumentTypesSlugRoute
}

const DocumentTypesRouteWithChildren = DocumentTypesRoute._addFileChildren(DocumentTypesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccountRoute: AccountRoute,AdsenseTestRoute: AdsenseTestRoute,AffiliatesRoute: AffiliatesRoute,AuthRoute: AuthRoute,ClauseHistoryRoute: ClauseHistoryRouteWithChildren,CompareRoute: CompareRoute,ContactRoute: ContactRoute,DocumentTypesRoute: DocumentTypesRouteWithChildren,HistoryRoute: HistoryRoute,HowItWorksRoute: HowItWorksRoute,NdaScannerRoute: NdaScannerRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RefundRoute: RefundRoute,ResetPasswordRoute: ResetPasswordRoute,TermsRoute: TermsRoute,UnsubscribeRoute: UnsubscribeRoute,ClausesSlugRoute: ClausesSlugRoute,LeaseRedFlagsStateRoute: LeaseRedFlagsStateRoute,QuestionsSlugRoute: QuestionsSlugRoute,ScenariosSlugRoute: ScenariosSlugRoute,ScenariosFirstApartmentLeaseRoute: ScenariosFirstApartmentLeaseRoute,SharedTokenRoute: SharedTokenRoute,ToolsSlugRoute: ToolsSlugRoute,BlogIndexRoute: BlogIndexRoute,ClausesIndexRoute: ClausesIndexRoute,QuestionsIndexRoute: QuestionsIndexRoute,BlogCategorySlugRoute: BlogCategorySlugRoute,BlogCategoryIndexRoute: BlogCategoryIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)